import { render, staticRenderFns } from "./MapaProcesos.vue?vue&type=template&id=978b7b3a&"
import script from "./MapaProcesos.vue?vue&type=script&lang=js&"
export * from "./MapaProcesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports